<template>
  <div :id="id" class="row align-items-center">
    <p class="col-12 mb-2">Aplíca un salto de página al momento de procesar un PDF.</p>
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
  </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
